module.exports = __webpack_public_path__ + "img/header-2.e9b0f21.jpg";